/* Remove internal search parameters from the TP961 address bar; keep variant and campaign parameters. */
(function(){
  const url=new URL(window.location.href);
  if(!/\/products\/tp961-tempspike-bluetooth-meat-thermometer\/?$/.test(url.pathname))return;
  let changed=false;
  ['_pos','_sid','_ss'].forEach(function(key){
    if(url.searchParams.has(key)){url.searchParams.delete(key);changed=true;}
  });
  if(changed)window.history.replaceState(window.history.state,'',url.href);
})();

/* TP961: keep the five valid pack/color combinations aligned with native variant selection. */
(function(){
  if(window.tp961PacksInitialized)return;
  window.tp961PacksInitialized=true;
  document.addEventListener('change',function(event){
    const input=event.target,root=input.closest('product-info[data-product-id="7821284704292"]');
    if(!root||!input.matches('variant-selects input[type="radio"]'))return;
    if(input.value==='1 Pack'){
      const mixed=root.querySelector('variant-selects input[value="Black + Green"]:checked');
      if(mixed){const green=root.querySelector('variant-selects input[value="Green"]');if(green)green.checked=true;}
    }
  },true);
  function initialMedia(){
    const root=document.querySelector('product-info[data-product-id="7821284704292"]');if(!root)return;
    const data=root.querySelector('[data-selected-variant]');if(!data)return;
    const variant=JSON.parse(data.textContent),media=variant&&variant.featured_media;
    if(!media)return;
    const gallery=root.querySelector('.media_r.swiper-container');
    if(!gallery||!gallery.swiper)return;
    const slides=[...gallery.querySelectorAll('.media_item.swiper-slide')];
    const index=slides.findIndex(s=>s.dataset.mediaId===String(media.id));
    if(index>=0){gallery.swiper.slideTo(index,0);root.querySelectorAll('.media_l .media_item').forEach((slide,i)=>slide.classList.toggle('active',i===index));const thumbs=root.querySelector('.media_l.swiper-container');if(thumbs&&thumbs.swiper)thumbs.swiper.slideTo(index,0);}
  }
  if(document.readyState==='complete')initialMedia();else window.addEventListener('load',initialMedia,{once:true});
})();
